import React from "react"
import PropTypes from "prop-types"

import CardWithIconTextDescription from "@components/CardWithIconTextDescription"

const CardWithIconTextDescriptionModule = ({ elements, classes }) => {
  return (
    <div className="mx-auto max-w-screen-fhd bg-white">
      <div
        className={`grid grid-cols-1 md:grid-cols-2 
    gap-10 md:gap-x-[74px] md:gap-y-10 fhd:gap-x-[178px] 
    fhd:gap-y-20 py-10 
    px-6 md:px-11 xl:p-25
    place-items-start md:max-w-[710px] xl:max-w-none fhd:max-w-[1774px] ${classes?.topDiv}`}
      >
        {elements.map((element, index) => (
          <CardWithIconTextDescription
            classes={classes}
            key={index}
            icon={element.icon}
            title={element.title}
            description={element.description}
            list={element.list}
          />
        ))}
      </div>
    </div>
  )
}

CardWithIconTextDescriptionModule.propTypes = {
  firstIcon: PropTypes.arrayOf(PropTypes.object),
}

export default CardWithIconTextDescriptionModule
